import { TextRenderConfig } from "./TextRenderConfig";
import { Browser } from "../../utils/Browser";
import { measureFont } from "./MeasureFont";
import { Texture2D } from "../../resource/Texture2D";
import { TextureFormat } from "../../RenderEngine/RenderEnum/TextureFormat";
import { FilterMode } from "../../RenderEngine/RenderEnum/FilterMode";
import { WrapMode } from "../../RenderEngine/RenderEnum/WrapMode";
import { LayaGL } from "../../layagl/LayaGL";
import { AtlasGrid } from "./AtlasGrid";
import { ILaya } from "../../../ILaya";
import { ColorUtils } from "../../utils/ColorUtils";
import { Config } from "../../../Config";
import { TextureArrayRegistry2D } from "../utils/TextureArrayRegistry2D";
export class TextRender {
    constructor(owner) {
        this.fontMap = new Map();
        this.textAtlases = [];
        this.charMap = new Map();
        this.textMap = new Map();
        this.freeRegions = [];
        this.freeIsoTextures = [];
        this.owner = owner;
        let canvas = Browser.createElement("canvas");
        this.canvas = canvas;
        canvas.width = 1024;
        canvas.height = 512;
        if (Browser.isDomSupported) {
            canvas.style.left = "-10000px";
            canvas.style.position = "absolute";
            Browser.document.body.appendChild(canvas);
        }
        this.ctx = canvas.getContext('2d', { willReadFrequently: true });
        ILaya.systemTimer.loop(5000, this, this.GC);
    }
    draw(text, x, y, font, fontSize, bold, italic, color, stroke, strokeColor, letterSpacing, shadowOffsetX, shadowOffsetY, shadowBlur, shadowColor, charMode, preMeasuredWidth, renderInfo) {
        let hasEmoji = emojiTest.test(text);
        let curFont = this.getFont(font);
        let info = bold ? curFont.bold : curFont.normal;
        let k = fontSize / TextRenderConfig.standardFontSize;
        fontSizeOffX = Math.ceil(info.xoff * k);
        emojiAdjustY = hasEmoji ? Math.ceil(info.eoff * k) : 0;
        fontSizeOffY = Math.ceil(info.yoff * k) + emojiAdjustY;
        fontSizeH = Math.ceil((hasEmoji ? info.ebbxh : info.bbxh) * k);
        fontScale = TextRenderConfig.fontScale;
        let italicDeg = italic ? 13 : 0;
        let cacheKey = (curFont.id * 10000) + fontSize + (bold ? "b_" : "_");
        let colorNum = ColorUtils.create(color).numColor;
        if (letterSpacing > 0)
            charMode = true;
        let shadow = shadowOffsetX !== 0 || shadowOffsetY !== 0;
        let tint = true;
        if (tint)
            cacheKey += colorNum + "_";
        if (stroke > 0)
            cacheKey += ColorUtils.create(strokeColor).numColor + "_" + stroke + "_";
        if (shadow)
            cacheKey += "shd_" + shadowOffsetX + "_" + shadowOffsetY + "_" + shadowBlur + "_" + ColorUtils.create(shadowColor).numColor + "_";
        let ctx = this.ctx;
        ctx.font = (bold ? "bold " : "") + fontSize + "px " + font;
        ctx.setTransform(fontScale, 0, 0, fontScale, 0, 0);
        ctx.textBaseline = "middle";
        ctx.fillStyle = tint ? color : 'white';
        if (stroke > 0) {
            ctx.lineJoin = "round";
            ctx.strokeStyle = strokeColor;
            ctx.lineWidth = stroke;
        }
        if (shadow) {
            ctx.shadowOffsetX = shadowOffsetX;
            ctx.shadowOffsetY = shadowOffsetY;
            ctx.shadowBlur = shadowBlur;
            ctx.shadowColor = shadowColor;
        }
        else {
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
            ctx.shadowBlur = 0;
        }
        if (!renderInfo)
            renderInfo = [];
        let drawColor = tint ? 0xffffffff : colorNum;
        if ((charMode || TextRenderConfig.forceSplitRender) && !TextRenderConfig.forceWholeRender) {
            let mat = this.owner._curMat;
            renderInfo.length > 0 && this.freeRenderInfo(renderInfo);
            for (let i = 0, len = text.length; i < len; i++) {
                let cc = text.charAt(i);
                let ccode = cc.charCodeAt(0);
                if (ccode >= 0xD800 && ccode <= 0xDBFF && i + 1 < len)
                    cc += text.charAt(++i);
                let key = cacheKey + cc;
                let ri = this.charMap.get(key);
                if (!ri) {
                    let width = ctx.measureText(cc).width;
                    ri = this.drawOffscreen(ctx, cc, width, fontSize, stroke, true);
                    ri.key = key;
                    ri.isChar = true;
                    this.charMap.set(key, ri);
                }
                ri.ref++;
                renderInfo.push(ri);
                this.owner._inner_drawTexture(ri.tex, ri.tex.id, x + ri.x, y + ri.y, ri.w, ri.h, mat, ri.uv, 1.0, cc.length > 1 ? 0xffffffff : drawColor, italicDeg, true);
                x += ri.advance + letterSpacing;
            }
        }
        else {
            let key = cacheKey + text;
            let ri = this.textMap.get(key);
            ri && ri.ref++;
            renderInfo[0] && this.free(renderInfo[0]);
            if (!ri) {
                if (preMeasuredWidth == null)
                    preMeasuredWidth = ctx.measureText(text).width;
                ri = this.drawOffscreen(ctx, text, preMeasuredWidth, fontSize, stroke, false);
                ri.key = key;
                ri.ref = 1;
                this.textMap.set(key, ri);
            }
            renderInfo[0] = ri;
            this.owner._inner_drawTexture(ri.tex, ri.tex.id, x + ri.x, y + ri.y, ri.w, ri.h, this.owner._curMat, ri.uv, 1.0, drawColor, italicDeg, true);
            for (let i = 1, n = renderInfo.length; i < n; i++)
                this.free(renderInfo[i]);
            renderInfo.length = 1;
        }
        return renderInfo;
    }
    drawOffscreen(ctx, text, width, height, lineWidth, charMode) {
        let offsetLeft = 0, offsetTop = 0, offsetRight = 0, offsetBottom = 0;
        if (ctx.shadowOffsetX > 0)
            offsetRight = ctx.shadowOffsetX;
        else if (ctx.shadowOffsetX < 0)
            offsetLeft = -ctx.shadowOffsetX;
        if (ctx.shadowOffsetY > 0)
            offsetBottom = ctx.shadowOffsetY;
        else if (ctx.shadowOffsetY < 0)
            offsetTop = -ctx.shadowOffsetY;
        let margin = height / 3 | 0 + lineWidth + Math.max(offsetLeft, offsetTop);
        let rectX = ((margin - fontSizeOffX - lineWidth - offsetLeft) * fontScale | 0) - blockGap;
        let rectY = ((margin - fontSizeOffY - lineWidth - offsetTop) * fontScale | 0) - blockGap;
        let correctionW = height * 0.08;
        let rectW = Math.ceil((width + fontSizeOffX + lineWidth * 2 + offsetLeft + offsetRight + correctionW) * fontScale) + blockGap * 2;
        let rectH = Math.ceil((fontSizeH + lineWidth * 2 + offsetTop + offsetBottom + 1) * fontScale) + blockGap * 2;
        let needCanvW = Math.min(rectW + Math.ceil(margin * 2 * fontScale), TextRenderConfig.maxCanvasWidth);
        let needCanvH = Math.min(rectH + Math.ceil(margin * 2 * fontScale), TextRenderConfig.maxCanvasWidth);
        if (needCanvW > this.canvas.width || needCanvH > this.canvas.height)
            this.resizeCanvas(ctx, needCanvW, needCanvH);
        ctx.clearRect(0, 0, Math.ceil(needCanvW / fontScale), Math.ceil(needCanvH / fontScale));
        lineWidth > 0 && ctx.strokeText(text, margin, margin + height / 2);
        ctx.fillText(text, margin, margin + height / 2);
        let imgdt = ctx.getImageData(rectX, rectY, rectW, rectH);
        if (TextRenderConfig.premultiplyAlpha) {
            let pix = imgdt.data.length / 4;
            let dt = imgdt.data;
            for (let i = 0; i < pix; i++) {
                let pos = i * 4;
                let k = dt[pos + 3] / 255;
                if (k > 0) {
                    dt[pos] = dt[pos] * k;
                    dt[pos + 1] = dt[pos + 1] * k;
                    dt[pos + 2] = dt[pos + 2] * k;
                }
            }
        }
        let ri = {
            x: -fontSizeOffX - lineWidth - offsetLeft,
            y: -emojiAdjustY - lineWidth - offsetTop,
            w: (imgdt.width - blockGap * 2) / fontScale,
            h: (imgdt.height - blockGap * 2) / fontScale,
            advance: width,
            uv: new Array(8),
            tex: null,
            region: null,
            ref: 0
        };
        if (imgdt.width > TextRenderConfig.atlasWidth || imgdt.height > TextRenderConfig.atlasWidth
            || !charMode && TextRenderConfig.noAtlas) {
            ri.tex = this.createIsoTexture(imgdt.width, imgdt.height);
            this.setPixelsToTexture(imgdt, ri.tex, 0, 0, ri.uv);
        }
        else {
            ri.region = this.addToAtlas(imgdt.width, imgdt.height);
            ri.tex = ri.region.owner.tex;
            this.setPixelsToTexture(imgdt, ri.tex, ri.region.x, ri.region.y, ri.uv);
        }
        return ri;
    }
    resizeCanvas(ctx, newWidth, newHeight) {
        newWidth = 512 * Math.ceil(newWidth / 512);
        newHeight = 512 * Math.ceil(newHeight / 512);
        let fontStr = ctx.font;
        let fillStyle = ctx.fillStyle;
        let strokeStyle = ctx.strokeStyle;
        let lineWidth = ctx.lineWidth;
        let shadowOffsetX = ctx.shadowOffsetX;
        let shadowOffsetY = ctx.shadowOffsetY;
        let shadowBlur = ctx.shadowBlur;
        let shadowColor = ctx.shadowColor;
        this.canvas.width = newWidth;
        this.canvas.height = newHeight;
        ctx.setTransform(fontScale, 0, 0, fontScale, 0, 0);
        ctx.font = fontStr;
        ctx.textBaseline = "middle";
        ctx.lineJoin = "round";
        ctx.fillStyle = fillStyle;
        ctx.strokeStyle = strokeStyle;
        ctx.lineWidth = lineWidth;
        ctx.shadowOffsetX = shadowOffsetX;
        ctx.shadowOffsetY = shadowOffsetY;
        ctx.shadowBlur = shadowBlur;
        ctx.shadowColor = shadowColor;
    }
    createIsoTexture(w, h) {
        let i = this.freeIsoTextures.findIndex(t => t != null && t.width >= w && t.width <= w + h && t.height >= h && t.height <= h + h);
        if (i !== -1) {
            let tex = this.freeIsoTextures[i];
            this.freeIsoTextures[i] = null;
            if (++freeIsoTextureNullCnt > 50) {
                this.freeIsoTextures = this.freeIsoTextures.filter(t => t != null);
                freeIsoTextureNullCnt = 0;
            }
            return tex;
        }
        else
            return this.createTextTexture(w, h);
    }
    addToAtlas(w, h) {
        let i = this.freeRegions.findIndex(r => r != null && r.w >= w && r.w <= w + h && r.h >= h && r.h <= h + h);
        if (i !== -1) {
            let region = this.freeRegions[i];
            this.freeRegions[i] = null;
            if (++freeRegionNullCnt > 50) {
                this.freeRegions = this.freeRegions.filter(r => r != null);
                freeRegionNullCnt = 0;
            }
            region.owner.ref++;
            return region;
        }
        let region;
        for (let ele of this.textAtlases) {
            if (region = ele.grid.allocate(w, h)) {
                region.owner = ele;
                ele.ref++;
                return region;
            }
        }
        let size = TextRenderConfig.atlasWidth;
        let atlas = {
            tex: this.createTextTexture(size, size),
            grid: new AtlasGrid(size, size, TextRenderConfig.atlasGridW),
            ref: 1
        };
        this.textAtlases.push(atlas);
        region = atlas.grid.allocate(w, h);
        region.owner = atlas;
        return region;
    }
    createTextTexture(width, height) {
        let tex = new Texture2D(width, height, TextureFormat.R8G8B8A8, false, false, true, true);
        tex.name = "TextTexture";
        tex.setPixelsData(null, true, false);
        tex.lock = true;
        tex.filterMode = FilterMode.Bilinear;
        tex.wrapModeU = WrapMode.Clamp;
        tex.wrapModeV = WrapMode.Clamp;
        if (Config.useTextureArray && TextRenderConfig.useTextureArray) {
            const alloc = TextureArrayRegistry2D.allocateLayerAsTexture(width, height, TextureFormat.R8G8B8A8, 64, false);
            if (alloc) {
                if (TextRenderConfig.premultiplyAlpha && alloc.array.gammaCorrection === 1) {
                    alloc.array._texture.gammaCorrection = 2.2;
                }
                TextureArrayRegistry2D.register(tex, alloc.array, alloc.layer);
            }
        }
        return tex;
    }
    setPixelsToTexture(imgdt, tex, x, y, outUv) {
        let data = imgdt.data;
        if (data instanceof Uint8ClampedArray)
            data = new Uint8Array(data.buffer);
        const reg = TextureArrayRegistry2D.resolve(tex);
        if (reg) {
            reg.array.setSubPixelsData(x, y, reg.layer, imgdt.width, imgdt.height, 1, data, 0, false, false, false);
        }
        else {
            LayaGL.textureContext.setTextureSubPixelsData(tex._texture, data, 0, false, x, y, imgdt.width, imgdt.height, !TextRenderConfig.premultiplyAlpha, false);
        }
        let u0 = (x + blockGap) / tex.width;
        let v0 = (y + blockGap) / tex.height;
        let u1 = (x + imgdt.width - blockGap) / tex.width;
        let v1 = (y + imgdt.height - blockGap) / tex.height;
        outUv[0] = u0, outUv[1] = v0;
        outUv[2] = u1, outUv[3] = v0;
        outUv[4] = u1, outUv[5] = v1;
        outUv[6] = u0, outUv[7] = v1;
    }
    freeRenderInfo(arr) {
        for (let ri of arr) {
            this.free(ri);
        }
        arr.length = 0;
    }
    free(ri) {
        ri.ref--;
        if (ri.ref > 0)
            return;
        if (ri.isChar) {
            if (ri.ref === 0)
                return;
            this.charMap.delete(ri.key);
        }
        else
            this.textMap.delete(ri.key);
        if (ri.region != null) {
            let atlas = ri.region.owner;
            atlas.ref--;
            if (atlas.ref === 0) {
                if (this.freeRegions.length > 0)
                    this.freeRegions = this.freeRegions.filter(r => r != null && r.owner !== atlas);
                freeRegionNullCnt = 0;
                if (this.textAtlases.length > 2 && this.textAtlases.findIndex((a) => a.ref === 0) !== -1) {
                    atlas.tex.destroy();
                    let idx = this.textAtlases.indexOf(atlas);
                    this.textAtlases.splice(idx, 1);
                }
                else {
                    atlas.grid.reset();
                }
            }
            else
                this.freeRegions.push(ri.region);
        }
        else {
            this.freeIsoTextures.push(ri.tex);
        }
    }
    getFontHeight(font, fontSize, bold) {
        let inst = this.getFont(font);
        let k = fontSize / TextRenderConfig.standardFontSize;
        let info = bold ? inst.bold : inst.normal;
        return Math.ceil(info.bbxh * k);
    }
    getFont(font) {
        let inst = this.fontMap.get(font);
        if (inst == null) {
            inst = {
                id: fontIdCounter++,
                normal: measureFont(this.ctx, font, false),
                bold: measureFont(this.ctx, font, true)
            };
            this.fontMap.set(font, inst);
        }
        return inst;
    }
    onFontScaleChanged() {
        this.textMap.clear();
        toClearChars.length = 0;
        for (let [_, ri] of this.charMap) {
            if (ri.ref === 0)
                toClearChars.push(ri);
            else
                ri.ref--;
        }
        for (let ri of toClearChars) {
            this.free(ri);
        }
        this.charMap.clear();
    }
    GC() {
        if (this.freeIsoTextures.length > 0) {
            for (let tex of this.freeIsoTextures)
                tex === null || tex === void 0 ? void 0 : tex.destroy();
            this.freeIsoTextures.length = 0;
            freeIsoTextureNullCnt = 0;
        }
        toClearChars.length = 0;
        for (let [_, ri] of this.charMap) {
            if (ri.ref === 0)
                toClearChars.push(ri);
        }
        for (let ri of toClearChars) {
            this.free(ri);
        }
    }
}
const blockGap = 1;
const emojiTest = /[\uD800-\uDBFF][\uDC00-\uDFFF]/;
var fontIdCounter = 0;
var fontScale = 1.0;
var fontSizeH = 0;
var fontSizeOffX = 0;
var fontSizeOffY = 0;
var emojiAdjustY = 0;
var freeRegionNullCnt = 0;
var freeIsoTextureNullCnt = 0;
var toClearChars = [];
